"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExportLogList = getExportLogList;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
// 获取导出日志列表
function getExportLogList(query) {
  return (0, _requestAuth.default)({
    url: '/xyWriteExcelLog/page',
    method: 'get',
    params: query
  });
}